import { featuresData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function FeaturesSection() {
  const ref = useScrollReveal();
  return (
    <section id="features" ref={ref} className="reveal-section py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            五大核心优势，打造最值得信赖的影视下载体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featuresData.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-accent-300/60 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-foreground-50 transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-sm mb-2">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-xs leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}